import { apiServer } from "../config/appConfig";
import axios from "axios";

const defaultUrl = () => {
  return "/v1/nextoken/admin/resource"
}

const setHeadersToken = (token) => {
  return {
    "Authorization" : token
  }
}

const resourceListService  = {

  getAllResourceList(token, params) {
    return axios({
      method: "get",
      url: apiServer + defaultUrl(),
      headers: setHeadersToken(token),
      params : params,
      crossOrigin: true,
    })
  },

  addResource(token, data) {
    return axios({
      method: "post",
      url: apiServer + defaultUrl(),
      headers: setHeadersToken(token),
      data : data,
      crossOrigin: true,
    })
  },

  editResource(token, data) {
    return axios({
      method: "put",
      url: apiServer + defaultUrl(),
      headers: setHeadersToken(token),
      data : data,
      crossOrigin: true,
    })
  },

  deleteResource(token, params) {
    return axios({
      method: "delete",
      url: apiServer + defaultUrl(),
      headers: setHeadersToken(token),
      params : params,
      crossOrigin: true,
    })
  },
  
}

export default resourceListService;